const TREEBUSINESS = {
    start: {
      label: "THE ULTIMATE BUSINESS CREDIT BLUEPRINT",
      details: (
        <ul>
          <li>From Zero to Wealth Using Business Credit — A Step-by-Step Execution Guide</li>
          <li>Results-driven execution manual, not just theory course</li>
          <li>For 9-5 employees to entrepreneurs, freelancers, investors, and aspiring founders</li>
          <li>Transform from zero credit profile to accessing $50k–$250k+ in real business funding</li>
        </ul>
      ),
      children: ["introduction", "phase1", "phase2", "phase3", "phase4", "phase5", "phase6"], // "templatesTools", "bonusModules"
      premium: 'true',
    },
    
    introduction: {
      label: "📘 INTRODUCTION",
      details: (
        <ul>
          <li>Welcome to the Blueprint - Quick orientation and how to get the most out of it</li>
          <li>What This Is (and Isn't) - Results-driven execution manual vs theory course</li>
          <li>Who This Is For - 9-5 employees to entrepreneurs and aspiring founders</li>
          <li>What You'll Accomplish by the End - Zero credit profile to $50k–$250k+ funding</li>
          <li>How to Use This Blueprint - Navigate, implement steps, track progress</li>
          <li>Business Credit vs Personal Credit - Key differences in liability and scoring</li>
          <li>Why Business Credit is the #1 Leverage Tool for Building Wealth</li>
          <li>Case Studies: From Zero to Six Figures in Funding</li>
        </ul>
      ),
      page: "static_html_content-business/introduction",
      children: [],
    },
    
    phase1: {
      label: "🧠 PHASE 1: MINDSET + FOUNDATIONS",
      details: (
        <ul>
          <li>Lay the psychological, legal, and structural foundation</li>
          <li>The Wealth Builder's Mindset - Consumer to Producer thinking</li>
          <li>Essential Business Structures - LLC vs Corporation</li>
          <li>EIN, DUNS, NAICS setup and requirements</li>
          <li>Business Contact Details and Bank Account Setup</li>
        </ul>
      ),
      page: "static_html_content-business/phase1-foundations",
      children: ["wealthMindset", "businessStructures", "einDunsNaics", "contactDetails", "bankSetup"],
      premium: 'true',
    },
    
    wealthMindset: {
      label: "1. The Wealth Builder's Mindset",
      details: (
        <ul>
          <li>Shift from Consumer to Producer: Stop thinking like a spender; start acting like an asset creator</li>
          <li>Leverage vs Liability Thinking: Understand when debt is bad — and when it's your most powerful tool</li>
          <li>Debt as a Tool for Scale: Learn to use strategic debt to unlock cash flow, scale faster, and create wealth</li>
        </ul>
      ),
      page: "static_html_content-business/wealth-mindset",
      children: [],
      premium: 'true',
    },
    
    businessStructures: {
      label: "2. Essential Business Structures",
      details: (
        <ul>
          <li>Choosing the Right Entity (LLC vs Corporation): Understand taxation, fundability, and legal protection</li>
          <li>How to Set Up a Compliant LLC (Step-by-Step): Name, Articles, Operating Agreement, EIN — in order</li>
          <li>Common Mistakes That Get You Denied: Learn what not to do when forming your company</li>
        </ul>
      ),
      page: "static_html_content-business/business-structures",
      children: [],
      premium: 'true',
    },
    
    einDunsNaics: {
      label: "3. EIN, DUNS, NAICS – What You Need and Why",
      details: (
        <ul>
          <li>Get Your EIN from IRS (Free): The unique business identifier you'll use for taxes and credit</li>
          <li>Register for DUNS Number: Required for reporting to Dun & Bradstreet — a must-have</li>
          <li>Pick the Right NAICS Code: Your business classification affects how banks and lenders view you</li>
        </ul>
      ),
      page: "static_html_content-business/ein-duns-naics",
      children: [],
      premium: 'true',
    },
    
    contactDetails: {
      label: "4. Business Contact Details",
      details: (
        <ul>
          <li>Business Address (Physical or Virtual): PO Boxes = red flag. Virtual office or CMRA recommended</li>
          <li>Business Phone (Toll-Free or VoIP): Setup with 411 listing for credibility</li>
          <li>Business Website & Domain Email: Gmail is a red flag. Use a custom domain + professional site</li>
        </ul>
      ),
      page: "static_html_content-business/contact-details",
      children: [],
      premium: 'true',
    },
    
    bankSetup: {
      label: "5. Business Bank Account Setup",
      details: (
        <ul>
          <li>Choosing the Right Bank (Tier 1 vs Fintech vs CU): Each has trade-offs. Start strategic</li>
          <li>Avoiding Common Mistakes: Mismatched business info, low opening deposits, or poor documentation</li>
          <li>Tier-1 Compliance Checklist: Ensure everything matches across IRS, DUNS, 411, bank, and secretary of state</li>
        </ul>
      ),
      page: "static_html_content-business/bank-setup",
      children: [],
      premium: 'true',
    },
    
    phase2: {
      label: "🧱 PHASE 2: BUILDING BUSINESS CREDIT PROFILE",
      details: (
        <ul>
          <li>Create a real, reportable business credit profile from scratch that lenders trust</li>
          <li>Business Credit Reporting Agencies (CRA) overview</li>
          <li>Understanding Your Business Credit Score types</li>
          <li>💎 PREMIUM: Tiered Vendor Strategy (Net 30, Net 60) - Full vetted list and sequencing</li>
          <li>Credit Profile Monitoring Tools</li>
        </ul>
      ),
      page: "static_html_content-business/phase2-building-profile",
      children: ["creditReportingAgencies", "businessCreditScore", "tieredVendorStrategy", "monitoringTools"],
      premium: 'true',
    },
    
    creditReportingAgencies: {
      label: "1. Business Credit Reporting Agencies (CRA)",
      details: (
        <ul>
          <li>Experian Business: The first to report many vendor tradelines</li>
          <li>Equifax Business: Reports loans, leases, and some fintech vendors</li>
          <li>Dun & Bradstreet (D&B): Crucial for Net 30 vendors and PAYDEX score</li>
          <li>SBFE & LexisNexis Overview: Behind-the-scenes databases used by banks</li>
        </ul>
      ),
      page: "static_html_content-business/credit-reporting-agencies",
      children: [],
      premium: 'true',
    },
    
    businessCreditScore: {
      label: "2. Your Business Credit Score",
      details: (
        <ul>
          <li>Understanding PAYDEX: D&B's on-time payment score (0–100)</li>
          <li>Understanding Intelliscore (Experian): Risk-based score, similar to FICO</li>
          <li>Understanding FICO SBSS: Used by SBA lenders; combines business + personal data</li>
          <li>How Lenders Actually Use These Scores: What matters most to them</li>
        </ul>
      ),
      page: "static_html_content-business/business-credit-score",
      children: [],
      premium: 'true',
    },
    
    tieredVendorStrategy: {
      label: "3. Tiered Vendor Strategy (Net 30, Net 60)",
      details: (
        <ul>
          <li>Tier 1 Vendors – Easy Approval to Start Building: e.g., Uline, Quill, Summa Office, Creative Analytics</li>
          <li>Tier 2 Vendors – Real Trade Lines with Impact: Grainger, Crown Office, Strategic Network Solutions</li>
          <li>Tier 3 & 4 – Banks and High-Limit Cards: Cards, fleet accounts, and store lines without PG</li>
          <li>Day-by-day application plan to avoid rejections</li>
          <li>Vendor sequencing for fastest file growth</li>
        </ul>
      ),
      page: "static_html_content-business/tiered-vendor-strategy",
      children: [],
      premium: 'true',
    },
    
    monitoringTools: {
      label: "4. Credit Profile Monitoring Tools",
      details: (
        <ul>
          <li>NAV: Multi-agency reporting tool, offers visibility and builder features</li>
          <li>CreditSignal by D&B: Free alerts and score movement</li>
          <li>Experian Business Monitoring: Paid access to full credit file</li>
          <li>How to Track Progress + Spot Errors: Check monthly and dispute issues fast</li>
        </ul>
      ),
      page: "static_html_content-business/monitoring-tools",
      children: [],
      premium: 'true',
    },
    
    phase3: {
      label: "💳 PHASE 3: GETTING BUSINESS CREDIT APPROVALS",
      details: (
        <ul>
          <li>Unlock real purchasing power and scale-ready credit lines</li>
          <li>Types of Business Credit to Target</li>
          <li>💎 PREMIUM: The 4 Tiers of Credit Approvals with examples</li>
          <li>💎 PREMIUM: Application Blueprint & Bank Relationship Scripts</li>
        </ul>
      ),
      page: "static_html_content-business/phase3-credit-approvals",
      children: ["typesBusinessCredit", "tiersApprovals", "applicationBlueprint"],
      premium: 'true',
    },
    
    typesBusinessCredit: {
      label: "1. Types of Business Credit to Target",
      details: (
        <ul>
          <li>Store Credit: Amazon, Home Depot, Apple — helps fund gear, tools, inventory</li>
          <li>Fleet Credit: Fuel and vehicle cards — Shell, WEX, ExxonMobil</li>
          <li>Business Charge Cards: Amex Gold, Divvy — pay in full each month</li>
          <li>Revolving Business Lines: Credit cards, lines of credit (LOCs)</li>
          <li>Business Loans & LOCs: Cash access from banks, fintechs, and CUs</li>
        </ul>
      ),
      page: "static_html_content-business/types-business-credit",
      children: [],
      premium: 'true',
    },
    
    tiersApprovals: {
      label: "2. The 4 Tiers of Credit Approvals",
      details: (
        <ul>
          <li>Tier 1: No PG (Personal Guarantee) Net 30s: Easy approvals to establish file</li>
          <li>Tier 2: Starter Business Credit Cards (PG): Personal credit backed, but builds biz credit</li>
          <li>Tier 3: No PG Cards & Lines (Bank Tier): Requires history and compliance</li>
          <li>Tier 4: Corporate Cards (Amex, Ramp, Brex): High-limit, no PG, often fintech or cash-flow based</li>
        </ul>
      ),
      page: "static_html_content-business/tiers-approvals",
      premium: 'true',
      children: [],
    },
    
    applicationBlueprint: {
      label: "3. Application Blueprint",
      details: (
        <ul>
          <li>Setting Up Fundability: Lender-ready profile alignment (name, phone, biz classification, etc.)</li>
          <li>How to Fill Business Credit Apps the Right Way: Exact wording, NAICS code consistency, biz age hacks</li>
          <li>Avoiding Red Flags That Lead to Denials: Don't use personal info, inconsistent addresses, or unsupported revenue</li>
          <li>Bank Relationship Strategies (Business Banker Scripts): What to say, when to say it, and how to ask</li>
        </ul>
      ),
      page: "static_html_content-business/application-blueprint",
      premium: 'true',
      children: [],
    },
    
    phase4: {
      label: "🚀 PHASE 4: LEVERAGING YOUR BUSINESS CREDIT",
      details: (
        <ul>
          <li>Turn credit into cash-flowing businesses, investments, and strategic growth</li>
          <li>💎 PREMIUM: Smart Uses of Business Credit for wealth building</li>
          <li>💎 PREMIUM: The Velocity Model of Wealth Building</li>
          <li>💎 PREMIUM: Creative Leverage Models and deployment strategies</li>
        </ul>
      ),
      page: "static_html_content-business/phase4-leveraging-credit",
      children: ["smartUses", "velocityModel", "creativeLeverage"],
      premium: 'true',
    },
    
    smartUses: {
      label: "1. Smart Uses of Business Credit",
      details: (
        <ul>
          <li>Fund a New Business or Side Hustle: Start with marketing, tools, or team</li>
          <li>Invest in Real Estate: Use LOCs or cards for down payment, rehab, or operations</li>
          <li>Purchase Equipment or Digital Assets: Use 0% cards for websites, automations, inventory</li>
          <li>Use for Marketing, Hiring, Inventory: Run profitable ad campaigns, onboard contractors</li>
        </ul>
      ),
      page: "static_html_content-business/smart-uses",
      premium: 'true',
      children: [],
    },
    
    velocityModel: {
      label: "2. The Velocity Model of Wealth Building",
      details: (
        <ul>
          <li>Stack Credit → Deploy Capital → Multiply Income: Build, invest, reinvest cycles</li>
          <li>Asset vs Liability: Strategic Capital Deployment: Don't use credit to consume — use it to build</li>
          <li>Credit-to-Cash Blueprint for systematic wealth building</li>
        </ul>
      ),
      page: "static_html_content-business/velocity-model",
      premium: 'true',
      children: [],
    },
    
    creativeLeverage: {
      label: "3. Creative Leverage Models",
      details: (
        <ul>
          <li>0% APR Hacking: Stack multiple 0% cards to create working capital float</li>
          <li>Credit Stacking with No PG: Time applications to avoid inquiries overlap and maximize approval</li>
          <li>Business Credit → Personal Wealth Transfer (Legally): How to compensate yourself legally</li>
        </ul>
      ),
      page: "static_html_content-business/creative-leverage",
      premium: 'true',
      children: [],
    },
    
    phase5: {
      label: "🧠 PHASE 5: ADVANCED STRATEGIES FOR SCALING",
      details: (
        <ul>
          <li>Operate like a capital strategist. Build moats, structures, and wealth systems</li>
          <li>💎 PREMIUM: Using Business Credit to Acquire Real Estate</li>
          <li>💎 PREMIUM: Funding E-Commerce or Digital Business</li>
          <li>💎 PREMIUM: Stacking Credit Across Multiple Entities</li>
          <li>💎 PREMIUM: Business Credit for Holding Companies</li>
        </ul>
      ),
      page: "static_html_content-business/phase5-advanced-strategies",
      children: ["realEstateCredit", "ecommerceDigital", "multipleEntities", "holdingCompanies"],
      premium: 'true',
    },
    
    realEstateCredit: {
      label: "1. Using Business Credit to Acquire Real Estate",
      details: (
        <ul>
          <li>DSCR Loan Bridge Strategy: Use credit lines for cash to qualify for no-income DSCR loans</li>
          <li>Using LOCs as Down Payments: Turn revolving credit into liquidity</li>
          <li>Business Credit → Airbnb Model: Launch or scale short-term rentals using OPM</li>
        </ul>
      ),
      page: "static_html_content-business/real-estate-credit",
      premium: 'true',
      children: [],
    },
    
    ecommerceDigital: {
        label: "2. Funding E-Commerce or Digital Business",
      details: (
        <ul>
          <li>Shopify + Business Credit: Frontload ad spend, inventory, and tools</li>
          <li>Amazon FBA Capital Flows: Pay suppliers and scale with float</li>
          <li>Affiliate/Lead Gen with Ad Spend: Fund marketing arbitrage operations</li>
        </ul>
      ),
      page: "static_html_content-business/ecommerce-digital",
      premium: 'true',
      children: [],
    },
    
    multipleEntities: {
      label: "3. Stacking Credit Across Multiple Entities",
      details: (
        <ul>
          <li>Multiple LLCs, One Owner Play: How to create and stagger credit across entities</li>
          <li>PG Rotation Strategy: Use different guarantors or intervals</li>
          <li>Risk Management + Legal: Stay compliant and protect yourself</li>
        </ul>
      ),
      page: "static_html_content-business/multiple-entities",
      premium: 'true',
      children: [],
    },
    
    holdingCompanies: {
      label: "4. Business Credit for Holding Companies",
      details: (
        <ul>
          <li>Asset Holding + Operations Split: Use parent-child LLCs to isolate liability</li>
          <li>Corporate Structure Optimization: Plan long-term wealth transfer and tax strategy</li>
        </ul>
      ),
      page: "static_html_content-business/holding-companies",
      premium: 'true',
      children: [],
    },
    
    phase6: {
      label: "🛡️ PHASE 6: PROTECTION & LONG-TERM STRATEGY",
      details: (
        <ul>
          <li>Maintain, monitor, and protect your credit and business growth</li>
          <li>Maintaining Your Business Credit Health</li>
          <li>Business Insurance, Compliance & Taxes</li>
          <li>Recession-Proofing with Business Credit</li>
        </ul>
      ),
      page: "static_html_content-business/phase6-protection-strategy",
      children: ["creditHealth", "insuranceCompliance", "recessionProofing"],
      premium: 'true',
    },
    
    creditHealth: {
      label: "1. Maintaining Your Business Credit Health",
      details: (
        <ul>
          <li>Monitoring, Updating, Disputes: Keep your reports accurate and optimized</li>
          <li>Vendor Rotation Strategy: Don't let accounts go stale — keep trade lines active</li>
          <li>Business Credit Tune-Up Checklist: Monthly/quarterly maintenance best practices</li>
        </ul>
      ),
      page: "static_html_content-business/credit-health",
      children: [],
      premium: 'true',
    },
    
    insuranceCompliance: {
      label: "2. Business Insurance, Compliance & Taxes",
      details: (
        <ul>
          <li>Liability Protection: Choose the right coverage and entity pairing</li>
          <li>Essential Filings to Stay Legit: Annual reports, compliance deadlines</li>
          <li>Write-Offs Using Business Credit: Maximize deductions using smart spend</li>
        </ul>
      ),
      page: "static_html_content-business/insurance-compliance",
      children: [],
      premium: 'true',
    },
    
    recessionProofing: {
      label: "3. Recession-Proofing with Business Credit",
      details: (
        <ul>
          <li>Emergency Lines of Credit: Prepare for volatility before you need it</li>
          <li>Vendor Financing in Tough Times: Build trust with vendors before a downturn</li>
          <li>Scaling Back or Pivoting with Funding: Adapt, don't collapse</li>
        </ul>
      ),
      page: "static_html_content-business/recession-proofing",
      children: [],
      premium: 'true',
    },
    
    templatesTools: {
      label: " TEMPLATES & TOOLS SECTION",
      details: (
        <ul>
          <li>Plug-and-play execution tools for fast implementation</li>
          <li>Ready-to-use templates, checklists, and automation tools</li>
          <li>Time-saving resources that accelerate your progress</li>
        </ul>
      ),
      page: "static_html_content-business/templates-tools",
      premium: 'true',
      children: ["llcFormationChecklist", "fundabilityChecklist", "applicationTemplates", "bankScripts", "vendorDatabase", "creditSpreadsheet", "notionTemplate", "executionCalendar", "integrationGuide", "printableJournal"],
    },
    
    llcFormationChecklist: {
      label: "LLC Formation Checklist",
      details: (
        <ul>
          <li>Step-by-step checklist for proper LLC formation</li>
          <li>State-specific requirements and filing procedures</li>
          <li>Operating agreement templates and best practices</li>
        </ul>
      ),
      page: "static_html_content-business/llc-formation-checklist",
      premium: 'true',
      children: [],
    },
    
    fundabilityChecklist: {
      label: "Fundability Compliance Checklist",
      details: (
        <ul>
          <li>Complete compliance checklist for lender approval</li>
          <li>Ensure all business details match across platforms</li>
          <li>Red flag identification and prevention guide</li>
        </ul>
      ),
      page: "static_html_content-business/fundability-checklist",
      premium: 'true',
      children: [],
    },
    
    applicationTemplates: {
      label: "Business Credit Application Templates",
      details: (
        <ul>
          <li>Fill-in-the-blank application templates</li>
          <li>Exact wording and NAICS code consistency guides</li>
          <li>Revenue reporting and business age optimization</li>
        </ul>
      ),
      page: "static_html_content-business/application-templates",
      premium: 'true',
      children: [],
    },
    
    bankScripts: {
      label: "Bank Call Scripts & Email Templates",
      details: (
        <ul>
          <li>Word-for-word scripts for banker conversations</li>
          <li>Email templates for relationship building</li>
          <li>Response templates for common banker questions</li>
        </ul>
      ),
      page: "static_html_content-business/bank-scripts",
      premium: 'true',
      children: [],
    },
    
    vendorDatabase: {
      label: "Tier 1–4 Vendor Database (Curated List)",
      details: (
        <ul>
          <li>Clickable, sortable vendor database</li>
          <li>Vetted vendors that actually report to credit bureaus</li>
          <li>Application timing and sequencing recommendations</li>
        </ul>
      ),
      page: "static_html_content-business/vendor-database",
      premium: 'true',
      children: [],
    },
    
    creditSpreadsheet: {
      label: "Credit Monitoring Spreadsheet",
      details: (
        <ul>
          <li>Track all credit applications and approvals</li>
          <li>Monitor credit scores across all bureaus</li>
          <li>Automated calculation and progress tracking</li>
        </ul>
      ),
      page: "static_html_content-business/credit-spreadsheet",
      premium: 'true',
      children: [],
    },
    
    notionTemplate: {
      label: "Business Credit Tracker Notion Template",
      details: (
        <ul>
          <li>Complete Notion dashboard for credit management</li>
          <li>Integrated tracking, reminders, and progress metrics</li>
          <li>Customizable templates for personal workflow</li>
        </ul>
      ),
      page: "static_html_content-business/notion-template",
      premium: 'true',
      children: [],
    },
    
    executionCalendar: {
      label: "\"90 Days to $100k\" Execution Calendar",
      details: (
        <ul>
          <li>Day-by-day execution plan to reach $100k credit</li>
          <li>Milestone tracking and deadline management</li>
          <li>Priority task scheduling and optimization</li>
        </ul>
      ),
      page: "static_html_content-business/execution-calendar",
      premium: 'true',
      children: [],
    },
    
    integrationGuide: {
      label: "Notion + Google Sheets Integration Guide",
      details: (
        <ul>
          <li>Connect Notion templates with Google Sheets tracking</li>
          <li>Automated data synchronization setup</li>
          <li>Advanced workflow optimization techniques</li>
        </ul>
      ),
      page: "static_html_content-business/integration-guide",
      premium: 'true',
      children: [],
    },
    
    printableJournal: {
      label: "Printable Blueprint Journal (PDF)",
      details: (
        <ul>
          <li>Physical journal for offline tracking and planning</li>
          <li>Progress worksheets and reflection prompts</li>
          <li>Goal setting and milestone celebration pages</li>
        </ul>
      ),
      page: "static_html_content-business/printable-journal",
      premium: 'true',
      children: [],
    },
    
    bonusModules: {
      label: "🧨 BONUS MODULES",
      details: (
        <ul>
          <li>Advanced strategies and automation tools</li>
          <li>Business scaling and monetization techniques</li>
          <li>Exclusive case studies and coaching resources</li>
        </ul>
      ),
      page: "static_html_content-business/bonus-modules",
      premium: 'true',
      children: ["aiAutomationTools", "makeZapierAutomation", "personalCreditImprovement", "coachingOffer", "investorPitchGuide", "caseStudies"],
    },
    
    aiAutomationTools: {
      label: "AI & Automation Tools for Credit Tracking",
      details: (
        <ul>
          <li>AI-powered credit monitoring and alert systems</li>
          <li>Automated application tracking and follow-up</li>
          <li>Smart notification and reminder systems</li>
        </ul>
      ),
      page: "static_html_content-business/ai-automation-tools",
      premium: 'true',
      children: [],
    },
    
    makeZapierAutomation: {
      label: "Make.com/Zapier Business Credit Automation",
      details: (
        <ul>
          <li>Complete automation workflows for credit management</li>
          <li>Auto-track approvals, set reminders, flag denials</li>
          <li>Integration with CRM and tracking systems</li>
        </ul>
      ),
      page: "static_html_content-business/make-zapier-automation",
      premium: 'true',
      children: [],
    },
    
    personalCreditImprovement: {
      label: "Using Business Credit to Improve Personal Credit",
      details: (
        <ul>
          <li>Strategies to leverage business credit for personal benefit</li>
          <li>Cross-utilization techniques and credit optimization</li>
          <li>Legal methods to improve personal credit profile</li>
        </ul>
      ),
      page: "static_html_content-business/personal-credit-improvement",
      premium: 'true',
      children: [],
    },
    
    coachingOffer: {
      label: "Turn This Blueprint Into a Coaching Offer",
      details: (
        <ul>
          <li>Complete coaching program templates and structures</li>
          <li>Pricing strategies and client onboarding processes</li>
          <li>Marketing materials and sales scripts</li>
        </ul>
      ),
      page: "static_html_content-business/coaching-offer",
      premium: 'true',
      children: [],
    },
    
    investorPitchGuide: {
      label: "Investor Pitch Guide: Use Credit to Fund the First Round",
      details: (
        <ul>
          <li>Leverage business credit to attract investors</li>
          <li>Pitch deck templates and presentation strategies</li>
          <li>Financial projections using credit as foundation</li>
        </ul>
      ),
      page: "static_html_content-business/investor-pitch-guide",
      premium: 'true',
      children: [],
    },
    
    caseStudies: {
      label: "$0 to $10k/Month Case Studies",
      details: (
        <ul>
          <li>Exclusive access to \"$100k in 90 days\" case studies</li>
          <li>Blog + YouTube Script Packs for content creation</li>
          <li>Real-world implementation examples and results</li>
        </ul>
      ),
      page: "static_html_content-business/case-studies",
      premium: 'true',
      children: [],
    },
  };
  
  export default TREEBUSINESS;
  export const ROOT_ID = "start";